/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { getSubmitData } from '../../store/state/epics/util';
import * as actionType from '../../store/state/actions';
import { logAndCatchError } from '../../utils/rxjs-utils';

const DXAPI_ERROR = 'Error occurred during ajax call at updateDataObject Epic';

const executeUpdateDataObjectRequest = (actionInPayload: any) => {
  const { dataPageID, context, headers, containerItemID, key } = actionInPayload;

  const requestPayloadAPI = {
    data_view_ID: dataPageID
  };

  const { restApi, reqType } = resolveRestApi(actionType.ACTION_UPDATE_DATA_OBJECT, requestPayloadAPI);

  const { content: requestPayload } = getSubmitData(containerItemID);
  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          'if-match': actionInPayload?.etag
        },
        body: {
          data: {
            ...requestPayload.content,
            ...key
          },
          pageInstructions: requestPayload.pageInstructions || []
        }
      },
      containerItemID
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeUpdateDataObjectRequest;
